/* eslint-disable no-use-before-define */
import React from 'react';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import parse from 'autosuggest-highlight/parse';
import match from 'autosuggest-highlight/match';
import { dropdown } from 'Utils/options';

interface CustomSearchBoxProps {
	label?: string;
	defaultValue?: any;
	itemList?: any;
	setSelected?: any;
	onClick?: any;
}
export const CustomSearchBox = ({
	label,
	defaultValue,
	itemList,
	setSelected,
	onClick,
}: CustomSearchBoxProps) => {
	const handleSelected = (option?: string) => {
		setSelected(option);
	};
	return (
		<Autocomplete
			style={{ borderRadius: '30px !important', background: 'white !important' }}
			id="highlights-demo"
			options={itemList || []}
			defaultValue={[defaultValue]}
			getOptionLabel={option => option.title}
			renderInput={params => <TextField {...params} label={label} variant="filled" />}
			onChange={
				// eslint-disable-next-line no-console
				(event, newValue) => {
					// eslint-disable-next-line no-console
					console.log(event, 'and my new value', newValue);
					newValue.id && onClick(newValue?.id);
				}
			}
			renderOption={(option, { inputValue }) => {
				const matches = match(option.title, inputValue);
				const parts = parse(option.title, matches);

				return (
					<div
					// onClick={() => onClick(option.id)}
					>
						{parts.map(
							(
								part: {
									highlight: any;
									text:
										| boolean
										| React.ReactChild
										| React.ReactFragment
										| React.ReactPortal
										| null
										| undefined;
								},
								index: React.Key | null | undefined,
							) => (
								<span key={index} style={{ fontWeight: part.highlight ? 700 : 400 }}>
									{part.text}
								</span>
							),
						)}
					</div>
				);
			}}
		/>
	);
};
